import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcDeleteIcon } from '@gem/icons';
import {
  FAB,
  FileIcon,
  FileIconState,
  getFileIconThemeByExt,
  FileName,
  PlayIcon,
  PlayIconState,
  PlayIconType,
} from '@gem/ui-kit';
import { getFileExt } from '@gem/utils';

import { PayloadType } from 'APP/model/message/messageModel.types';

import { IItemMediaPresenter } from '../ItemMedia.presenter';
import styles from './MediaMessageFile.styles.m.css';

interface IMediaMessageFileProps {
  presenter: IItemMediaPresenter;
}

export const MediaMessageFile: FC<IMediaMessageFileProps> = observer(({ presenter }) => {
  const fileExt = getFileExt(presenter.name);

  return (
    <div className={styles.file}>
      {presenter.payloadType === PayloadType.AudioMessage ? (
        <PlayIcon
          type={PlayIconType.Play}
          state={PlayIconState.Regular}
        />
      ) : (
        <FileIcon
          text={fileExt}
          theme={getFileIconThemeByExt(fileExt)}
          state={FileIconState.Regular}
        />
      )}
      <div className={styles.content}>
        <FileName name={presenter.name} />
        <div className={styles.size}>{presenter.size}</div>
      </div>
      {presenter.canBeRemoved && (
        <div className={styles.deletePanel}>
          <FAB
            className={styles.delete}
            Icon={IcDeleteIcon}
            onClick={presenter.onRemove}
            size="30"
            theme="6"
          />
        </div>
      )}
    </div>
  );
});
